//paths
export const PCREATE_USER = '/v1/user/create';
export const PGET_POLLS_TAKEN = '/v1/user/polls_taken';
export const PGET_POLLS_CREATED = '/v1/user/polls_created';
export const PGET_USERNAME = '/v1/user/check_username';
export const PGET_USERINFO= '/v1/user/info';
export const PGET_MATCH_SCORE = '/v1/user/match_score';

export const PCREATE_POLL = '/v1/poll/create';
export const PGET_POLL = '/v1/poll/get/'; //expects pollid appended to end
export const PSEARCH_POLLS = '/v1/poll/search/'; //expects query appended to end
export const PEDIT_POLL = '/v1/poll/edit';
export const PGET_POLL_RES = '/v1/poll/get_results/'; //expects pollid appended to end
export const PVOTE_POLL = '/v1/poll/vote'; //TODO POST
export const PRANDOM_POLL = '/v1/poll/random';
export const PGEN_S3URL = '/v1/poll/s3url';
export const PGET_TWTS = '/v1/poll/get_tweets/'; //expects query appended to end
export const PEDIT_USER= '/v1/user/edit';
export const PFOLLOW_USER= '/v1/user/follow';
export const PDELETE_POLL= '/v1/poll/delete';



// WEBPACK FOOTER //
// ./src/actions/paths.js